import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Location from "nexia_mobile/models/location";

import connect from "nexia_mobile/flux_like/store/connect";
import FetchManager from "nexia_mobile/components/Details/FetchManager";
import Page from "nexia_mobile/components/Page";
import OverlayLinearProgress from "nexia_mobile/components/OverlayLinearProgress";
import ScrollableAreaWithPullToRefresh from "nexia_mobile/components/Scrollable/ScrollableAreaWithPullToRefresh";
import TileList from "nexia_mobile/components/TileList";
import PivotDemoMessage from "nexia_mobile/components/Commercial/PivotDemoMessage";
import PivotDemoBanner from "nexia_mobile/components/Commercial/PivotDemoBanner";

class DashboardTilesPage extends React.Component {
  static propTypes = {
    appBar: PropTypes.element.isRequired,
    location: PropTypes.instanceOf(Location).isRequired,
    tileItems: PropTypes.instanceOf(Backbone.Collection).isRequired,
    backgroundLoading: PropTypes.bool.isRequired,
  };

  render() {
    const { location, tileItems, appBar, backgroundLoading } = this.props;

    return (
      <FetchManager model={location}>
        {({
          progressShown,
          runPromiseWithProgress,
          fetchModelAndMaybeDetails,
        }) => (
          <Page name="DashboardTilesPage" fullyLoaded>
            {appBar}
            {(progressShown || backgroundLoading) && (
              <OverlayLinearProgress indeterminate />
            )}
            <ScrollableAreaWithPullToRefresh
              onPullToRefresh={() => {
                runPromiseWithProgress(fetchModelAndMaybeDetails);
              }}
              pullToRefreshDisabled={progressShown}
              trackingKey="DashboardTilesPage"
            >
              <TileList collection={tileItems} />
            </ScrollableAreaWithPullToRefresh>
            <PivotDemoMessage />
            <PivotDemoBanner />
          </Page>
        )}
      </FetchManager>
    );
  }
}

export default connect(
  {
    backgroundLoading: "backgroundLoading",
  },
  DashboardTilesPage
);



// WEBPACK FOOTER //
// ./src/components/Pages/DashboardTilesPage.jsx